import app from 'flarum/forum/app';
const TTL = 5 * 60 * 1000;
const MAX_ENTRIES = 200;
const MAX_BATCH_SIZE = 20;
const FLUSH_DELAY = 50;
const FLUSH_TIMEOUT = 30000;
const UNKNOWN = 'unknown';
const LOADING = {
  status: 'loading'
};
const entries = new Map();
const pending = new Map();
const retained = new Map();
const queue = [];
let timer = null;
let flushing = false;
export function previewFor(url) {
  return entries.get(url)?.state ?? LOADING;
}
export function loadPreview(url, onChange) {
  const waiting = pending.get(url);
  if (waiting) {
    waiting.add(onChange);
    return;
  }
  const entry = entries.get(url);
  if (entry && entry.expires > Date.now()) return;
  if (entry?.state.status === 'failed') entries.delete(url);
  pending.set(url, new Set([onChange]));
  queue.push(url);
  schedule();
}
export function retainPreview(url) {
  retained.set(url, (retained.get(url) ?? 0) + 1);
}
export function releasePreview(url) {
  const count = (retained.get(url) ?? 0) - 1;
  if (count > 0) {
    retained.set(url, count);
  } else {
    retained.delete(url);
  }
}
function schedule() {
  if (timer !== null) return;
  timer = setTimeout(flush, FLUSH_DELAY);
}
function flush() {
  timer = null;
  if (flushing || queue.length === 0) return;
  flushing = true;
  const batch = queue.splice(0, MAX_BATCH_SIZE);
  let released = false;
  const release = () => {
    if (released) return;
    released = true;
    clearTimeout(guard);
    flushing = false;
    if (queue.length > 0) schedule();
  };
  const guard = setTimeout(release, FLUSH_TIMEOUT);
  send(batch).catch(() => undefined).finally(release);
}
function send(urls) {
  if (app.forum.attribute('datlechin-link-preview.batchRequests') ?? true) {
    return sendBatch(urls);
  }
  return Promise.all(urls.map(sendOne)).then(() => undefined);
}
async function sendBatch(urls) {
  let data = {};
  try {
    const response = await app.request({
      method: 'POST',
      url: `${app.forum.attribute('apiUrl')}/datlechin-link-preview/batch`,
      body: {
        urls
      },
      errorHandler: quietly
    });
    data = response?.data ?? {};
  } catch {}
  urls.forEach(url => settle(url, data[url]));
}
async function sendOne(url) {
  let data;
  try {
    const response = await app.request({
      method: 'POST',
      url: `${app.forum.attribute('apiUrl')}/datlechin-link-preview`,
      body: {
        url
      },
      errorHandler: quietly
    });
    data = response?.data;
  } catch {}
  settle(url, data);
}
function quietly() {}
function settle(url, data) {
  entries.set(url, {
    state: stateFor(data),
    expires: Date.now() + TTL
  });
  evict();
  const waiting = pending.get(url);
  pending.delete(url);
  waiting?.forEach(onChange => onChange());
}
function stateFor(data) {
  if (!data) return {
    status: 'failed',
    code: UNKNOWN
  };
  if ('error' in data) return {
    status: 'failed',
    code: data.error || UNKNOWN
  };
  return {
    status: 'ready',
    data
  };
}
function evict() {
  for (const oldest of Array.from(entries.keys())) {
    if (entries.size <= MAX_ENTRIES) break;
    if (retained.has(oldest)) continue;
    entries.delete(oldest);
  }
}
flarum.reg.add('datlechin-link-preview', 'forum/utils/previewStore', { previewFor: previewFor,loadPreview: loadPreview,retainPreview: retainPreview,releasePreview: releasePreview, });